import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';

export interface PickemEntry {
  userId: string;
  username: string;
  entryDate: string | null;
  points: number | null;
  rank: number | null;
}

export interface PickemEntriesResponse {
  entries: PickemEntry[];
  total: number;
  limit: number;
  offset: number;
}

export interface UserSelection {
  questionId: string;
  questionText: string;
  optionId: string | null;
  optionText: string;
  customValue: string | null;
  isCorrect: boolean | null;
  pointsEarned: number;
}

export interface UserSelectionsResponse {
  selections: UserSelection[];
}

export const getPickemEntries = (
  pickemId: string,
  params?: { limit?: number; offset?: number }
): Promise<PickemEntriesResponse> => api.get(apiEndpoints.getPickemEntries(pickemId), { params });

export const getUserSelections = (
  pickemId: string,
  userId: string
): Promise<UserSelectionsResponse> =>
  api.get(apiEndpoints.getPickemUserSelections(pickemId, userId));

export const useGetPickemEntriesQuery = (
  pickemId?: string,
  params?: { limit?: number; offset?: number }
) => {
  return useQuery({
    queryKey: queryKeys.pickems.entries(pickemId!),
    queryFn: () => getPickemEntries(pickemId!, params),
    enabled: !!pickemId,
  });
};

export const useGetUserSelectionsQuery = (pickemId?: string, userId?: string) => {
  return useQuery({
    queryKey: queryKeys.pickems.userSelections(pickemId!, userId!),
    queryFn: () => getUserSelections(pickemId!, userId!),
    enabled: !!pickemId && !!userId,
  });
};
